import type { FooterBlockContent, SocialLink } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface FooterBlockEditorProps {
  content: FooterBlockContent | null
  onChange: (content: FooterBlockContent) => void
}

const SOCIAL_LABELS = ["Facebook", "Twitter", "Instagram", "LinkedIn"] as const

export function FooterBlockEditor({ content, onChange }: FooterBlockEditorProps) {
  const c = content ?? {}
  const socialLinks = (c.social_links ?? []) as SocialLink[]
  const update = (partial: Partial<FooterBlockContent>) =>
    onChange({ ...c, ...partial })

  const getUrl = (label: string) =>
    socialLinks.find((l) => l.label === label)?.url ?? ""
  const setUrl = (label: string, url: string) => {
    const next = socialLinks.filter((l) => l.label !== label)
    if (url.trim()) next.push({ label, url: url.trim() })
    update({ social_links: next })
  }

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Footer</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Tagline</Label>
          <Input
            value={c.tagline ?? "Creating change together."}
            onChange={(e) => update({ tagline: e.target.value })}
            placeholder="Creating change together."
          />
        </div>
        <div className="space-y-2">
          <Label>Social links (optional)</Label>
          {SOCIAL_LABELS.map((label) => (
            <Input
              key={label}
              placeholder={`${label} URL`}
              value={getUrl(label)}
              onChange={(e) => setUrl(label, e.target.value)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
